import { render } from "./SaasServicesPage.vue?vue&type=template&id=4fa5a841&scoped=true"
import script from "./SaasServicesPage.vue?vue&type=script&lang=js"
export * from "./SaasServicesPage.vue?vue&type=script&lang=js"

import "./SaasServicesPage.vue?vue&type=style&index=0&id=4fa5a841&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa5a841"]])

export default __exports__